import { render, staticRenderFns } from "./ViewNewPassword.vue?vue&type=template&id=4b546240&"
import script from "./ViewNewPassword.vue?vue&type=script&lang=js&"
export * from "./ViewNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./ViewNewPassword.vue?vue&type=style&index=0&id=4b546240&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports